// extracted by mini-css-extract-plugin
export default {"globalLoader":"_4656b2423e711eae"};